import { checkPermissionByKey } from "../utils/checkPermissionByKey";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import EarlyAccessQueue from "../components/Dashboard/EarlyAccessQueue";
import CareManagerDashboard from "../components/Dashboard/CareManagerDashboard";
import ProviderDashboard from "../components/Dashboard/ProviderDashboard";
import ProviderOnboardingDashboard from "../components/Dashboard/ProviderOnboardingDashboard";
import { isIncompleteTherapist } from "../utils/providerOnboarding";

const isTherapistProvider = (user) =>
  user?.role === "provider" &&
  user?.role !== "careManager" &&
  user?.providerType !== "Care Manager" &&
  user?.providerType !== "Psychiatric Consultant";

const Dashboard = () => {
  const user = useSelector((state) => state?.user);
  const isCareManager =
    user?.user?.role === "careManager" ||
    user?.user?.providerType === "Care Manager";
  const showProviderOnboarding = isIncompleteTherapist(user?.user);
  const showTherapistDashboard =
    isTherapistProvider(user?.user) && !showProviderOnboarding;
  const businessId = user.user?.businessId;
  const businessIdentifier = user.user?.businessIdentifier;

  const [activeUsers, setActiveUsers] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [newUsers, setNewUsers] = useState(0);
  const [appointmentStats, setAppointmentStats] = useState({
    completedAppointments: 0,
    completedMinutes: 0,
    scheduledAppointments: 0,
    scheduledMinutes: 0,
  });
  const [filter, setFilter] = useState("thisMonth");

  const fetchNewUsers = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/users/getnewuserscount?businessId=${businessId}&businessIdentifier=${businessIdentifier}`,
      );
      setNewUsers(response.data.count ?? 0);
    } catch (error) {
      if (error.response?.status === 404) {
        setNewUsers(0);
        return;
      }
      console.error("🚀 -> fetchNewUsers -> error:", error);
    }
  };

  const fetchActiveUsers = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/users/getactiveUsersCount?businessId=${businessId}&businessIdentifier=${businessIdentifier}`,
      );
      setActiveUsers(response.data.count);
    } catch (error) {
      console.error("🚀 -> fetchActiveUsers -> error:", error);
    }
  };

  const fetchTotalUsers = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/users/getalluserscount?businessId=${businessId}&businessIdentifier=${businessIdentifier}`,
      );
      setTotalUsers(response.data.count);
    } catch (error) {
      console.error("🚀 -> fetchTotalUsers -> error:", error);
    }
  };

  const handleFilterChange = async (e) => {
    e.preventDefault();
    setFilter(e.target.value);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/appointment/metrics/${e.target.value}?businessId=${user.user?.businessId}&businessIdentifier=${user.user?.businessIdentifier}`,
        {
          headers: {
            Authorization: `Bearer ${user.user?.token}`,
          },
        },
      );
      setAppointmentStats(response.data);
    } catch (error) {
      console.error("🚀 -> handleFilterChange -> error:", error);
    }
  };

  useEffect(() => {
    if (isCareManager) return;

    fetchNewUsers();
    fetchActiveUsers();
    fetchTotalUsers();
  }, [isCareManager]);

  useEffect(() => {
    if (isCareManager) return;

    const fetchStats = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/appointment/metrics/${filter}?businessId=${user.user?.businessId}&businessIdentifier=${user.user?.businessIdentifier}`,
          {
            headers: {
              Authorization: `Bearer ${user.user?.token}`,
            },
          },
        );
        setAppointmentStats(response.data);
      } catch (error) {
        console.error("🚀 -> handleFilterChange -> error:", error);
      }
    };
    fetchStats();
  }, [filter, isCareManager]);

  if (isCareManager) {
    return <CareManagerDashboard />;
  }

  if (showProviderOnboarding) {
    return <ProviderOnboardingDashboard />;
  }

  if (showTherapistDashboard) {
    return <ProviderDashboard />;
  }

  return (
    <>
      {checkPermissionByKey(
        user,
        "viewDashboard",
        "ViewDashboardListAccess",
      ) && (
        <div className="dashboard">
          <div className="grid-container">
            <div className="card">
              <h2>Total Users</h2>
              <p>{totalUsers}</p>
            </div>
            <div className="card">
              <h2>Active Users</h2>
              <p>{activeUsers}</p>
            </div>
            <div className="card">
              <h2>New Users (&lt;30 days)</h2>
              <p>{newUsers}</p>
            </div>
          </div>

          {/* Schedule Stats */}
          {/* <select
            className="form-select"
            onChange={handleFilterChange}
            style={{
              border: "1px solid #B760E5",
              borderRadius: "4px",
              color: "#B760E5",
              fontWeight: 600,
              height: "46px",
              margin: "46px 0",
              padding: "0 16px",
              width: "25.75%",
            }}
            value={filter}
          >
            <option value="thisMonth">This Month</option>
            <option value="nextMonth">Next Month</option>
            <option value="lastMonth">Last Month</option>
            <option value="last90Days">Last 90 Days</option>
            <option value="thisYear">This Year</option>
            <option value="lastYear">Last Year</option>
          </select>
          <div className="grid-container">
            <div className="card">
              <h2>Scheduled Appointments</h2>
              <p>{appointmentStats.scheduledAppointments}</p>
            </div>
            <div className="card">
              <h2>Completed Appointments</h2>
              <p>{appointmentStats.completedAppointments}</p>
            </div>
            <br />
            <div className="card">
              <h2>Scheduled Minutes</h2>
              <p>{appointmentStats.scheduledMinutes}</p>
              </div>
            <div className="card">
              <h2>Completed Minutes</h2>
              <p>{appointmentStats.completedMinutes}</p>
            </div>
          </div> */}

          <EarlyAccessQueue />
        </div>
      )}
    </>
  );
};

export default Dashboard;
